// extracted by mini-css-extract-plugin
module.exports = {"row":"style_row__1UJIa","title":"style_title__1249l","rows":"style_rows__rXWEN"};